import { createAction, props } from '@ngrx/store';

export enum GroupRideActions {
    groupRideShowOnMap = '[group ride] show on map',
    groupRideHideOnMap = '[group ride] hide on map',
}

export const GroupRideShowOnMap = createAction(
    GroupRideActions.groupRideShowOnMap,
    props<{ groupRideId: string }>()
);

export const GroupRideHideOnMap = createAction(
    GroupRideActions.groupRideHideOnMap
);
